import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import SelectField from '../../shared/form-elements/select/field';
import Input from '../../shared/form-elements/input';

const Form = ({
	handleSubmit,
	submitForm,
	intl,
	location_path,
	can,
	loadAffiliatesLookup,
	payoutCurrencies,
	loadGeosLookup,
	loadCrmGeosLookup,
	resetGeoAndAffiliate,
	loadOffersLookup
}) => {
	const isEditForm = location_path.includes('geo-payout-rates/edit');
	return (
		<div className="form-container approved-reject-form">
			<div className="form-container__head">
				<h2>{ intl(isEditForm ? 'Edit restricted geo payout' : 'Create restricted geo payout') }</h2>
			</div>

			<div className="form-container__body">
				<form className="ui-form create-cpl-rule" onSubmit={handleSubmit(data => submitForm(data))}>

					<div className="ui-form__element">
						<Field
							name="offer_id"
							searchable={true}
							placeholder={intl('Offer')}
							multi={false}
							component={SelectField}
							onChange={resetGeoAndAffiliate}
							options={loadOffersLookup}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="country_code"
							searchable={true}
							placeholder={intl('Geo')}
							multi={false}
							component={SelectField}
							options={loadGeosLookup}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="crm_region_id"
							searchable={true}
							placeholder={intl('Region')}
							multi={false}
							component={SelectField}
							options={loadCrmGeosLookup.bind(null, 'regions')}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="crm_city_id"
							searchable={true}
							placeholder={intl('City')}
							multi={false}
							component={SelectField}
							options={loadCrmGeosLookup.bind(null, 'city')}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="crm_district_id"
							searchable={true}
							placeholder={intl('District')}
							multi={false}
							component={SelectField}
							options={loadCrmGeosLookup.bind(null, 'districts')}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="affiliate_id"
							searchable={true}
							placeholder={intl('Affiliate')}
							multi={false}
							component={SelectField}
							options={loadAffiliatesLookup}
						/>
					</div>
					{
						payoutCurrencies.map((currency, index) =>
							<div className="payouts-container" key={index}>
								<div className="ui-form__element">
									<Field
										name={`${currency}_payout`}
										placeholder={intl(`Payouts ${currency}`)}
										component={Input}
									/>
								</div>
							</div>
						)
					}

					<div className="ui-form__element buttons">
						{can('geoPayoutRatesEdit') &&
							<button className="ui-btn ui-btn-primary">
								{intl('Save')}
							</button>}
						{<Link to="geo-payout-rates/">
							<button type="button" className="ui-btn ui-btn-cancel">
								{intl('Cancel')}
							</button>
						</Link>}
					</div>
				</form>
			</div>
		</div>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func,
	loadOffersLookup: PropTypes.func,
	loadAffiliatesLookup: PropTypes.func
};

const requiredFields = ['country_code', 'rub_payout', 'usd_payout'];

const validate = values => {
	const errors = {};

	requiredFields.forEach((field) => {
		if (isEmpty(values[field])) {
			errors[field] = 'required';
		}
	});

	return errors;
};

export default reduxForm({
	form: 'geoPayoutRatesForm',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/geo-payout-rates/components/form.js